import { Suspense, lazy, ElementType } from 'react';
// components
import LoadingScreen from '@raas/shared/src/components/minimals/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component: ElementType) => (props: any) => (
  <Suspense fallback={<LoadingScreen />}>
    <Component {...props} />
  </Suspense>
);

// ----------------------------------------------------------------------

export const LoginPage = Loadable(lazy(() => import('@raas/shared/src/pages/LoginPage')));

export const LegalProvisionListPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/legal-provision/LegalProvisionListPage'))
);

export const LegalRadarPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/legal-radar/LegalRadarPage'))
);

export const LegalProvisionCreatePage = Loadable(
  lazy(() => import('@raas/shared/src/pages/legal-provision/LegalProvisionCreatePage'))
);
export const LegalProvisionEditPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/legal-provision/LegalProvisionEditPage'))
);
export const LegalProvisionNewVersionPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/legal-provision/LegalProvisionNewVersionPage'))
);
export const LegalProvisionDetailsPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/legal-provision/LegalProvisionDetailsPage'))
);
export const LegalProvisionAccessPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/legal-provision/LegalProvisionAccessPage'))
);
export const LegalProvisionWithTranslationPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/legal-provision/LegalProvisionWithTranslationPage'))
);
export const DocumentElementCreatePage = Loadable(
  lazy(() => import('@raas/shared/src/pages/document-element/DocumentElementCreatePage'))
);
export const DocumentElementEditPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/regulation-element/RegulationElementEditPage'))
);
export const DocumentElementViewPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/regulation-element/RegulationElementViewPage'))
);
export const SentenceFragmentsPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/SentenceFragmentsPage'))
);
export const LegalRequirementListPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/legal-requirement/LegalRequirementListPage'))
);
export const LegalRequirementCreatePage = Loadable(
  lazy(() => import('@raas/shared/src/pages/legal-requirement/LegalRequirementCreatePage'))
);
export const LegalRequirementEditPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/legal-requirement/LegalRequirementEditPage'))
);
export const PropertyListPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/property/PropertyListPage'))
);
export const PropertyCreatePage = Loadable(
  lazy(() => import('@raas/shared/src/pages/property/PropertyCreatePage'))
);
export const PropertyEditPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/property/PropertyEditPage'))
);
export const TechnicalRequirementListPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/technical-requirement/TechnicalRequirementListPage'))
);
export const TechnicalRequirementCreatePage = Loadable(
  lazy(() => import('@raas/shared/src/pages/technical-requirement/TechnicalRequirementCreatePage'))
);
export const TechnicalRequirementEditPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/technical-requirement/TechnicalRequirementEditPage'))
);
export const InputListPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/input/InputListPage'))
);
export const InputEditPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/input/InputEditPage'))
);
export const InputCreatePage = Loadable(
  lazy(() => import('@raas/shared/src/pages/input/InputCreatePage'))
);

export const TagGroupListPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/tag-group/TagGroupListPage'))
);
export const TagGroupCreatePage = Loadable(
  lazy(() => import('@raas/shared/src/pages/tag-group/TagGroupCreatePage'))
);
export const TagGroupEditPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/tag-group/TagGroupEditPage'))
);

export const TagListPage = Loadable(lazy(() => import('@raas/shared/src/pages/tag/TagListPage')));
export const TagCreatePage = Loadable(
  lazy(() => import('@raas/shared/src/pages/tag/TagCreatePage'))
);
export const TagEditPage = Loadable(lazy(() => import('@raas/shared/src/pages/tag/TagEditPage')));

export const ReleaseCreatePage = Loadable(
  lazy(() => import('@raas/shared/src/pages/release/ReleaseCreatePage'))
);

export const UserChangePassword = Loadable(
  lazy(() => import('@raas/shared/src/pages/user/Account'))
);

export const Page404 = Loadable(lazy(() => import('@raas/shared/src/pages/Page404')));

export const AlertsListPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/alerts/AlertsListPage'))
);

export const AlertsEditPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/alerts/AlertsEditPage'))
);

export const ExportsListPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/exports/ExportsListPage'))
);

export const ExportsEditPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/exports/ExportsEditPage'))
);

export const ReportsListPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/reports/ReportsListPage'))
);

export const ImportPage = Loadable(lazy(() => import('@raas/shared/src/pages/import/ImportPage')));

export const RegulationListPage = Loadable(
  lazy(() => import('@raas/shared/src/features/regulation/pages/RegulationListPage'))
);

export const RegulationPropertyListPage = Loadable(
  lazy(() => import('@raas/shared/src/features/regulation/pages/RegulationPropertyListPage'))
);

export const DeltaPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/delta/DeltaLegalProvisionPage'))
);

export const AdminPage = Loadable(lazy(() => import('@raas/shared/src/pages/admins/AdminPage')));

export const IntegrationSettingsPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/integration/IntegrationSettingsPage'))
);

export const IntegrationPage = Loadable(
  lazy(() => import('@raas/shared/src/pages/integration/IntegrationPage'))
);

export const UserProfilePage = Loadable(
  lazy(() => import('@raas/shared/src/common/pages/UserProfilePage'))
);

export const SubscriptionCreatePage = Loadable(
  lazy(() => import('@raas/shared/src/features/subscription/pages/SubscriptionCreatePage'))
);

export const EditSubscriptionPage = Loadable(
  lazy(() => import('@raas/shared/src/features/subscription/pages/EditSubscriptionPage'))
);

export const BundlingListPage = Loadable(
  lazy(() => import('@raas/shared/src/features/bundling/pages/BundlingListPage'))
);

export const BundlingCreatePage = Loadable(
  lazy(() => import('@raas/shared/src/features/bundling/pages/BundlingCreatePage'))
);

export const BundlingEditPage = Loadable(
  lazy(() => import('@raas/shared/src/features/bundling/pages/BundlingEditPage'))
);

export const AttributeListPage = Loadable(
  lazy(() => import('@raas/shared/src/features/attribute/pages/AttributeListPage'))
);

export const RegulationContentPage = Loadable(
  lazy(() => import('@raas/shared/src/features/regulation/pages/RegulationContentPage'))
);

export const RegulationAccessCreatePage = Loadable(
  lazy(() => import('@raas/shared/src/features/access/pages/RegulationAccessCreatePage'))
);

export const OrganizationListPage = Loadable(
  lazy(() => import('@raas/shared/src/features/organization/pages/OrganizationListPage'))
);

export const OrganizationPage = Loadable(
  lazy(() => import('@raas/shared/src/features/organization/pages/OrganizationPage'))
);

export const OrganizationGroupListPage = Loadable(
  lazy(() => import('@raas/shared/src/features/organization/pages/OrganizationGroupListPage'))
);

export const OrganizationGroupPage = Loadable(
  lazy(() => import('@raas/shared/src/features/organization/pages/OrganizationGroupPage'))
);

export const OrganizationMemberListPage = Loadable(
  lazy(() => import('@raas/shared/src/features/organization/pages/OrganizationMemberListPage'))
);

export const OrganizationGroupMemberListPage = Loadable(
  lazy(() => import('@raas/shared/src/features/organization/pages/OrganizationGroupMemberListPage'))
);

export const OrganizationGroupRegulationListPage = Loadable(
  lazy(
    () => import('@raas/shared/src/features/organization/pages/OrganizationGroupRegulationListPage')
  )
);

export const AccessRegulationCreatePage = Loadable(
  lazy(() => import('@raas/shared/src/features/access/pages/AccessRegulationCreatePage'))
);
